import {
    ShowAllNAttachmentsWithSize,
    NAttachmentsWithSize,
    ShowAllNAttachments,
} from './getAttachmentWellInfoString.locstring.json';
import { NAttachments } from 'owa-locstrings/lib/strings/nattachments.locstring.json';
import loc, { format } from 'owa-localize';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';
import { numberToByteQuantifiedStringConverter } from 'owa-file';

export default function getAttachmentWellInfoString(
    attachmentWell: AttachmentWellViewState,
    didViewOverflowOneRow: boolean,
    isShowingMultipleRows: boolean
): string {
    const attachmentCount: number =
        attachmentWell.docViewAttachments.length + attachmentWell.imageViewAttachments.length;
    const totalSize: number = attachmentWell.totalClassicAttachmentSize;
    const appendShowAll = didViewOverflowOneRow && !isShowingMultipleRows;
    if (totalSize > 0) {
        const formatString = appendShowAll
            ? loc(ShowAllNAttachmentsWithSize)
            : loc(NAttachmentsWithSize);
        const totalSizeString = numberToByteQuantifiedStringConverter(totalSize);
        return format(formatString, attachmentCount, totalSizeString);
    } else {
        const formatString = appendShowAll ? loc(ShowAllNAttachments) : loc(NAttachments);
        return format(formatString, attachmentCount);
    }
}
